// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareBucketModal_overlay__DACLz {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ShareBucketModal_modal__hvpVf {
  background: rgba(24, 26, 27, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: white;
}

.ShareBucketModal_header__1ckqo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.ShareBucketModal_header__1ckqo h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #4a9eff;
  font-weight: bold;
}

.ShareBucketModal_closeButton__iJzKO {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #ccc;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.ShareBucketModal_closeButton__iJzKO:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.ShareBucketModal_content__WWuKy {
  flex: 1 1;
  padding: 1.5rem;
  overflow-y: auto;
}

.ShareBucketModal_section__JbEdJ {
  margin-bottom: 1.5rem;
}

.ShareBucketModal_section__JbEdJ h3 {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  color: white;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 0.5rem;
}

.ShareBucketModal_sharedUsers__V9CVP {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.ShareBucketModal_sharedUser__6sydL {
  display: flex;
  align-items: center;
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 20px;
  padding: 0.25rem 0.5rem;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.ShareBucketModal_sharedUser__6sydL span {
  color: #1976d2;
  font-weight: 500;
}

.ShareBucketModal_removeButton__oJT4H {
  background: none;
  border: none;
  color: #1976d2;
  cursor: pointer;
  font-size: 1rem;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.ShareBucketModal_removeButton__oJT4H:hover {
  background-color: #1976d2;
  color: white;
}

.ShareBucketModal_removeButton__oJT4H:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ShareBucketModal_userList__h29nn {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 0.5rem;
  background: rgba(40, 40, 40, 0.5);
  /* Custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.ShareBucketModal_userList__h29nn::-webkit-scrollbar {
  width: 6px;
}

.ShareBucketModal_userList__h29nn::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.ShareBucketModal_userList__h29nn::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.ShareBucketModal_userList__h29nn::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.ShareBucketModal_userItem__Yyrfb {
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background-color 0.2s;
}

.ShareBucketModal_userItem__Yyrfb:hover {
  background: rgba(255, 255, 255, 0.02);
}

.ShareBucketModal_userItem__Yyrfb:last-child {
  border-bottom: none;
}

.ShareBucketModal_userLabel__rolkZ {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
}

.ShareBucketModal_userLabel__rolkZ input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
  accent-color: #4a9eff;
}

.ShareBucketModal_userLabel__rolkZ span {
  color: white;
}

.ShareBucketModal_currentlyShared__pgR1K {
  color: #4a9eff !important;
  font-size: 0.75rem !important;
  font-style: italic;
  margin-left: 0.5rem;
}

.ShareBucketModal_error__eFjPw {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.ShareBucketModal_footer__kNODH {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.ShareBucketModal_cancelButton__m9XnL {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.ShareBucketModal_cancelButton__m9XnL:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.ShareBucketModal_shareButton__xLdOr {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.ShareBucketModal_shareButton__xLdOr:hover {
  background: #3a8aff;
}

.ShareBucketModal_shareButton__xLdOr:disabled {
  background: #ccc;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .ShareBucketModal_modal__hvpVf {
    width: 95%;
    max-height: 90vh;
  }
  
  .ShareBucketModal_header__1ckqo,
  .ShareBucketModal_content__WWuKy,
  .ShareBucketModal_footer__kNODH {
    padding: 1rem;
  }
  
  .ShareBucketModal_header__1ckqo h2 {
    font-size: 1.1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ShareBucketModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal {\r\n  background: rgba(24, 26, 27, 0.95);\r\n  backdrop-filter: blur(15px);\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: white;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  color: #4a9eff;\r\n  font-weight: bold;\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: #ccc;\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.closeButton:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n}\r\n\r\n.content {\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n  overflow-y: auto;\r\n}\r\n\r\n.section {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.section h3 {\r\n  margin: 0 0 0.75rem 0;\r\n  font-size: 1rem;\r\n  color: white;\r\n  font-weight: 600;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.sharedUsers {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.sharedUser {\r\n  display: flex;\r\n  align-items: center;\r\n  background: #e3f2fd;\r\n  border: 1px solid #bbdefb;\r\n  border-radius: 20px;\r\n  padding: 0.25rem 0.5rem;\r\n  gap: 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.sharedUser span {\r\n  color: #1976d2;\r\n  font-weight: 500;\r\n}\r\n\r\n.removeButton {\r\n  background: none;\r\n  border: none;\r\n  color: #1976d2;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.removeButton:hover {\r\n  background-color: #1976d2;\r\n  color: white;\r\n}\r\n\r\n.removeButton:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.userList {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n  padding: 0.5rem;\r\n  background: rgba(40, 40, 40, 0.5);\r\n  /* Custom scrollbar */\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\r\n}\r\n\r\n.userList::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.userList::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n\r\n.userList::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 3px;\r\n}\r\n\r\n.userList::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.userItem {\r\n  padding: 0.5rem 0;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.userItem:hover {\r\n  background: rgba(255, 255, 255, 0.02);\r\n}\r\n\r\n.userItem:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.userLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.userLabel input[type=\"checkbox\"] {\r\n  margin: 0;\r\n  cursor: pointer;\r\n  accent-color: #4a9eff;\r\n}\r\n\r\n.userLabel span {\r\n  color: white;\r\n}\r\n\r\n.currentlyShared {\r\n  color: #4a9eff !important;\r\n  font-size: 0.75rem !important;\r\n  font-style: italic;\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.error {\r\n  background-color: rgba(244, 67, 54, 0.1);\r\n  color: #f44336;\r\n  border: 1px solid rgba(244, 67, 54, 0.3);\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  padding: 1.5rem;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.cancelButton {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.shareButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.shareButton:hover {\r\n  background: #3a8aff;\r\n}\r\n\r\n.shareButton:disabled {\r\n  background: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .modal {\r\n    width: 95%;\r\n    max-height: 90vh;\r\n  }\r\n  \r\n  .header,\r\n  .content,\r\n  .footer {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .header h2 {\r\n    font-size: 1.1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ShareBucketModal_overlay__DACLz`,
	"modal": `ShareBucketModal_modal__hvpVf`,
	"header": `ShareBucketModal_header__1ckqo`,
	"closeButton": `ShareBucketModal_closeButton__iJzKO`,
	"content": `ShareBucketModal_content__WWuKy`,
	"section": `ShareBucketModal_section__JbEdJ`,
	"sharedUsers": `ShareBucketModal_sharedUsers__V9CVP`,
	"sharedUser": `ShareBucketModal_sharedUser__6sydL`,
	"removeButton": `ShareBucketModal_removeButton__oJT4H`,
	"userList": `ShareBucketModal_userList__h29nn`,
	"userItem": `ShareBucketModal_userItem__Yyrfb`,
	"userLabel": `ShareBucketModal_userLabel__rolkZ`,
	"currentlyShared": `ShareBucketModal_currentlyShared__pgR1K`,
	"error": `ShareBucketModal_error__eFjPw`,
	"footer": `ShareBucketModal_footer__kNODH`,
	"cancelButton": `ShareBucketModal_cancelButton__m9XnL`,
	"shareButton": `ShareBucketModal_shareButton__xLdOr`
};
export default ___CSS_LOADER_EXPORT___;
